module.exports = __webpack_public_path__ + "static/img/brees-2013-slide-3.4e02406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-slide-3.jpg
// module id = rrtj
// module chunks = 1